import Vue from 'vue';

const FileUploader = {
  inserted(el, binding) {

    if (el) {
      Vue.prototype.$fileuploader(binding.value);
    }
  }
}

// You can also make it available globally.
Vue.directive('file-uploader', FileUploader);

export default FileUploader;